import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress, Box, Typography } from '@mui/material';
import { approvePurchase, rejectBitPurchase } from '../api/purchases';
import { PendingPurchase } from './AllPurchasesPage';



interface PendingPurchasesTableProps {
  onRefresh?: () => void;
  pendingPurchases:PendingPurchase[];
  loading:boolean

}

function PendingPurchasesTable({loading, pendingPurchases, onRefresh }: PendingPurchasesTableProps): React.JSX.Element {
  const [processingId, setProcessingId] = useState<string | null>(null);

  const handleApprove = async (related_id: string, create_receipt: boolean) => {
    if (processingId) return;
    setProcessingId(related_id);
    try {
      await approvePurchase(related_id,create_receipt);
      onRefresh?.();
    } finally {
      setProcessingId(null);
    }
  };

  const handleBitReject = async (related_id: string) => {
    if (processingId) return;
    setProcessingId(related_id);
    try {
      await rejectBitPurchase(related_id);
      onRefresh?.();
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <>
      {pendingPurchases.length > 0 ? (
        <TableContainer component={Paper} sx={{ width: '100%', mb: 3 }}>
          <Typography variant="h6" sx={{ p: 2 }}>הזמנות ממתינות</Typography>
          <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>שם הורה</TableCell>
                  <TableCell>טלפון הורה</TableCell>
                  <TableCell>סכום</TableCell>
                  <TableCell>שחיינים</TableCell>
                  <TableCell>קורסים</TableCell>
                  <TableCell>הערות</TableCell>
                  <TableCell>פעולה</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : (
                  pendingPurchases?.map((purchase) => (
                  <TableRow key={purchase.related_id}>
                    <TableCell>{purchase.parentName}</TableCell>
                    <TableCell>{purchase.parentPhone}</TableCell>
                    <TableCell>{purchase.amount}</TableCell>
                    <TableCell>{purchase.swimmers}</TableCell>
                    <TableCell>{purchase.variants}</TableCell>
                    <TableCell>{purchase.notes || 'אין הערות'}</TableCell>
                    <TableCell>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!!processingId}
                        onClick={() => handleApprove(purchase.related_id, true)}
                      >
                        {processingId === purchase.related_id ? <CircularProgress size={20} /> : 'אשר'}
                      </Button>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!!processingId}
                        onClick={() => handleApprove(purchase.related_id, false)}
                        sx={{ ml: 1 }}
                      >
                        אשר ללא חשבונית
                      </Button>
                      <Button
                        size="small"
                        variant="contained"
                        color="error"
                        disabled={!!processingId}
                        onClick={() => handleBitReject(purchase.related_id)}
                        sx={{ ml: 1 }}
                      >
                        סרב
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
                )}
              </TableBody>
            </Table>
        </TableContainer>
      ) : (
        <Box sx={{ width: '100%', textAlign: 'center', mb: 3 }}>
          <Typography variant="h6" sx={{ p: 2 }}>אין הזמנות ממתינות</Typography>
        </Box>
      )}
    </>
  );
}

export default PendingPurchasesTable; 